function generateId() {
  // 32-bit unsigned integer (max ~4.2 billion)
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0]; // this is your random numeric ID
}

export default generateId;

